import { ChannelPayloadFilter, ViewStream } from "spyne";
//import { CodeContainerPropertiesContent } from "components/code-examples/code-container-properties-content";
import { gsap } from "gsap";

export class CodeContainerPropertiesBackground extends ViewStream {
  constructor(props = {}) {
    props.id = "code-container-properties-background";
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    //console.log("THIS DETAILS VSID ",parentVsid);
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.vsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_UPDATED",
        "onChannelCodeUpdate",
        isCodeBlockIdFilter,
      ],
    ];
  }

  onChannelCodeUpdate(e) {
    if (this === undefined || this.props === undefined) {
      return;
    }

    const data = e.payload;

    const { height, width, isStartPosition } = e.payload;
    const { parentVsid, codeBlockId } = this.props;

    //console.log("HEIGHT IS ",{isStartPosition, height, isStartPosition, data},e);

    if (isStartPosition === true) {
      gsap.set(this.props.el, { opacity: 1 });
      this.props.el.style.cssText = `height:"${height}px";"`;
    } else {
      const onTlComplete = () => (this.props.el.cssText = "");

      const tl = new gsap.timeline();
      tl.set(this.props.el, { opacity: 1 });
      tl.to(this.props.el, {
        height: height,
        duration: 0.35,
        ease: "power1.inOut",
      });
      tl.to(this.props.el, { opacity: 0.3, delay: 1, duration: 0.25 });
      tl.play();
    }

    //console.log("onChannelCodeUpdate ", {data,parentVsid, codeBlockId});
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    this.addChannel("CHANNEL_CODE_CONTAINER");
  }
}
